<template>
  <v-skeleton-loader
    :loading="loading"
    :endpoint="endpoint"
    :boilerplate="boilerplate"
    :dark="dark"
    :elevation="elevation"
    :height="height"
    :light="light"
    :max-height="maxHeight"
    :max-width="maxWidth"
    :min-width="minWidth"
    :tile="tile"
    :transition="transition"
    :type="type"
    :types="types"
    :width="width"
  >
    <slot></slot>
  </v-skeleton-loader>
</template>


<script>
export default {
  name: 'AnchorLoader',
  props: {
    endpoint: {
      type: String,
      required: true,
    },
    boilerplate: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    elevation: [String, Number],
    height: [String, Number],
    light: {
      type: Boolean,
      default: false,
    },
    maxHeight: [String, Number],
    maxWidth: [String, Number],
    minWidth: [String, Number],
    tile: {
      type: Boolean,
      default: false,
    },
    transition: String,
    type: String,
    types: {
      type: Object,
      default: () => {},
    },
    width: [String, Number],
  },
  data: () => ({
    loading: true,
  }),
  methods: {
    fetch() {
      this.loading = true;
      this.$requests.get(this.endpoint)
        .then(response => {
          this.$emit('success', response);
          this.loading = false;
        })
        .catch(err => {
          this.$emit('error', err.response);
          this.loading = false;
        });
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
